<template>
  <div>
    <div class="page">
      <div class="one">
        <div class="two">
          <el-form ref="form">
            <el-form-item prop="keyword" label-width="60">
              <el-date-picker
                v-model="created_at"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="created_at">
              <el-input
                placeholder="请输入内容"
                v-model="input3"
                class="input-with-select"
              >
                <el-select
                  style="width: 120px"
                  v-model="search.select"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option label="团长名称" value="1"></el-option>
                  <el-option label="达人名称" value="2"></el-option>
                  <el-option label="渠道BD" value="3"></el-option>
                  <el-option label="产品名称" value="4"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item prop="created_at">
              <el-button
                style="background-color: #229fa0; color: #f6f7fb"
                @click="getAll()"
                >搜索</el-button
              >
              <el-button
                @click="getAll2()"
                style="background-color: #229fa0; color: #f6f7fb"
                >重置</el-button
              >
              <!-- <el-button
                style="background-color: #229fa0; color: #f6f7fb"
                type="primary"
                @click="dialogFormVisible = true"
                >录入领样订单</el-button
              > -->
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%" center>
          <el-table-column
            align="center"
            prop="created_at"
            label="创建日期"
            width="158"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="experts"
            label="达人姓名"
            width="100"
          >
            <template slot-scope="scope">
              <div
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ scope.row.experts }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="guige"
            align="center"
            width="220"
            label=" 规格"
          >
            <template slot-scope="scope">
              <div
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ scope.row.guige }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="post_name" align="center" label="收货人">
          </el-table-column>
          <el-table-column
            prop="product_name"
            align="center"
            label="产品名称"
            width="220"
          >
            <template slot-scope="scope">
              <div
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ scope.row.product_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="快递单号" width="100" align="center">
            <template slot-scope="scope">
              <div class="btn_option">
                <el-button
                  v-if="scope.row.express != null"
                  style="background-color: #229fa0; color: #f6f7fb"
                  size="small"
                  @click="checknumber(scope.row.express)"
                  >查询物流</el-button
                >
                <el-button
                  v-else
                  align="center"
                  type="danger"
                  size="small"
                  @click="checknumber(scope.row.express)"
                  ><span style="color: #354356">未发货</span></el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="colonel" align="center" label="团长名称">
          </el-table-column>
          <el-table-column
            prop="post_telephone"
            align="center"
            width="120"
            label="收货电话"
          >
          </el-table-column>
          <el-table-column prop="channel_name" align="center" label="渠道BD">
          </el-table-column>
          <el-table-column
            prop="job_status"
            align="center"
            width="140px"
            sortable
            label="传送状态"
          >
            <template slot-scope="scope">
              <div class="btn_option">
                <span v-if="scope.row.job_status == 2">
                  <el-button
                    size="mini"
                    type="success"
                    @click="open(scope.row.job_remakr)"
                    >已播</el-button
                  >
                </span>
                <span v-if="scope.row.job_status == 1">
                  <el-button
                    size="mini"
                    type="info"
                    @click="open(scope.row.job_remakr)"
                  >
                    排期中</el-button
                  >
                </span>
                <span v-if="scope.row.job_status == 0">
                  <el-button
                    size="mini"
                    type="info"
                    @click="open(scope.row.job_remakr)"
                    >未播</el-button
                  >
                </span>
                <span v-if="scope.row.job_status == 3">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="open(scope.row.job_remakr)"
                    >未通过</el-button
                  >
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column width="250" label="操作" align="center">
            <template slot-scope="scope">
              <div>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      ><el-button
                        style="background-color: #229fa0; color: #f6f7fb"
                        size="small"
                        @click="checkOption(scope.row)"
                        >修改</el-button
                      ></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><el-button
                        type="danger"
                        size="small"
                        @click="del(scope.row.id)"
                        >删除</el-button
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <!--  -->
                <el-button
                  style="background-color: #229fa0; color: #f6f7fb"
                  size="small"
                  @click="checkOption2(scope.row)"
                  >详情</el-button
                >
                <!--  -->
                <el-button
                  style="background-color: #229fa0; color: #f6f7fb"
                  size="small"
                  @click="querynum(scope.row.id)"
                  >上传作业</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationStyle">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div>
      <el-dialog
        title="录入领样订单"
        :visible.sync="dialogFormVisible"
        width="30%"
        @close="guanbi"
      >
        <el-form :model="forminput" ref="forminput2" :rules="loginformrules">
          <el-form-item
            label="达人姓名"
            :label-width="formLabelWidth"
            prop="experts"
          >
            <el-autocomplete
              style="width: 100%"
              class="inline-input"
              v-model="forminput.experts"
              :fetch-suggestions="proIdSearch"
              placeholder="请输入内容"
              @select="proIdSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item
            label="达人id"
            :label-width="formLabelWidth"
            prop="experts_id"
          >
            <el-input
              v-model="forminput.experts_id"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="产品名称"
            :label-width="formLabelWidth"
            prop="product_name"
          >
            <el-input
              v-model="forminput.product_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="规格" :label-width="formLabelWidth" prop="guige">
            <el-input v-model="forminput.guige" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="份数"
            :label-width="formLabelWidth"
            prop="fenshu"
          >
            <el-input v-model="forminput.fenshu" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="	收货人"
            :label-width="formLabelWidth"
            prop="post_name"
          >
            <el-input
              v-model="forminput.post_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="	收货电话"
            :label-width="formLabelWidth"
            prop="post_telephone"
          >
            <el-input
              v-model="forminput.post_telephone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="收货地址"
            :label-width="formLabelWidth"
            prop="post_address"
          >
            <el-input
              v-model="forminput.post_address"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团长名称"
            :label-width="formLabelWidth"
            prop="colonel"
          >
            <el-input v-model="forminput.colonel" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="快递单号"
            :label-width="formLabelWidth"
            prop="express"
          >
            <el-input v-model="forminput.express" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
            style="background-color: #229fa0; color: #f6f7fb"
            @click="getadd()"
            :disabled="show"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        title="修改订单"
        :visible.sync="dialogFormVisible2"
        width="30%"
      >
        <el-form :model="updateform" ref="updateform2" :rules="loginformrules">
          <el-form-item
            label="达人ID"
            :label-width="formLabelWidth"
            prop="experts_id"
          >
            <el-input
              v-model="updateform.experts_id"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="达人姓名"
            :label-width="formLabelWidth"
            prop="experts"
          >
            <el-input
              v-model="updateform.experts"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="产品名称"
            :label-width="formLabelWidth"
            prop="product_name"
          >
            <el-input
              v-model="updateform.product_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="规格" :label-width="formLabelWidth" prop="guige">
            <el-input v-model="updateform.guige" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="份数"
            :label-width="formLabelWidth"
            prop="fenshu"
          >
            <el-input v-model="updateform.fenshu" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item
            label="	收货电话"
            :label-width="formLabelWidth"
            prop="post_telephone"
          >
            <el-input
              v-model="updateform.post_telephone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="	收货人"
            :label-width="formLabelWidth"
            prop="post_name"
          >
            <el-input
              v-model="updateform.post_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="收货地址"
            :label-width="formLabelWidth"
            prop="post_address"
          >
            <el-input
              v-model="updateform.post_address"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团长名称"
            :label-width="formLabelWidth"
            prop="colonel"
          >
            <el-input
              v-model="updateform.colonel"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="快递单号"
            :label-width="formLabelWidth"
            prop="express"
          >
            <el-input
              v-model="updateform.express"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            style="background-color: #229fa0; color: #f6f7fb"
            @click="dialogFormVisible2 = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="update()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        title="物流信息展示"
        :visible.sync="dialogFormVisible3"
        width="30%"
        @close="guanbi2"
      >
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible3 = false">取 消</el-button>
          <!-- <el-button type="primary" @click="querynumber()">确 定</el-button> -->
        </div>
        <div>
          <p>
            <span>物流订单号：{{ this.wuliu.no }}</span>
          </p>
          <p>
            <span>物流名称：{{ this.wuliu.cname }}</span>
          </p>
          <p>
            <span>
              个人信息
              <span v-for="(item, index) in this.wuliu.content" :key="index">
                <p>
                  {{ item.time }}
                </p>
                <p>
                  {{ item.content }}
                </p>
              </span>
            </span>
          </p>
        </div>
      </el-dialog>
    </div>
    <!-- 上传作业 -->
    <div>
      <el-dialog
        title="上传作业"
        :visible.sync="dialogFormVisible4"
        width="30%"
        @close="guanbi3"
      >
        <el-form :model="updateform" ref="updateform5">
          <el-form-item
            label="作业状态"
            prop="experts_id"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="updateform.job_status"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="作业备注"
            prop="job_remakr"
            :label-width="formLabelWidth"
          >
            <el-input
              type="textarea"
              v-model="updateform.job_remakr"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible4 = false">取 消</el-button>
          <el-button type="primary" @click="update2()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 信息展示 -->
    <el-dialog title="作业详情" :visible.sync="dialogFormVisible5" width="30%">
      <div>
        {{ this.updateform.job_remakr }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible5 = false">取 消</el-button>
        <!-- <el-button type="primary" @click="update2()">确 定</el-button> -->
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="dialogFormVisible6" width="30%">
      <div style="margin: 0 60px">
        <p>达人ID : {{ this.updateform.experts_id }}</p>
        <p>达人姓名 : {{ this.updateform.experts }}</p>
        <p>产品名称 : {{ this.updateform.product_name }}</p>
        <p>规格 : {{ this.updateform.guige }}</p>
        <p>份数 : {{ this.updateform.fenshu }}</p>
        <p>收货人 : {{ this.updateform.post_name }}</p>
        <p>收货电话 : {{ this.updateform.post_telephone }}</p>
        <p>收货地址 : {{ this.updateform.post_address }}</p>
        <p>团长名称 : {{ this.updateform.colonel }}</p>
        <p>快递单号 : {{ this.updateform.express }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible6 = false">取 消</el-button>
        <!-- <el-button type="primary" @click="update()">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import preventReClick from '../../unils/preventReClickpreventReClick'
import { Add, Getlist, Update, Epress, Del, myExperts } from '@/api/api2'
export default {
  data() {
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }

    var validatorFenshu = function (rule, value, callback) {
      if (value != '') {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error('请填写大于0的数字'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      input3: '',
      role: sessionStorage.getItem('role'),
      username: sessionStorage.getItem('username'),
      loginformrules: {
        colonel: [
          { required: true, message: '请输入相关内容', trigger: 'blur' },
        ],
        post_telephone: [
          { required: true, validator: validatorPhone, trigger: 'blur' },
        ],
        fenshu: [
          {
            required: true,
            validator: validatorFenshu,
            trigger: 'change',
          },
        ],
      },
      show: false,
      options: [
        {
          value: '0',
          label: '未播',
        },
        {
          value: '1',
          label: '排期中',
        },
        {
          value: '2',
          label: '已播',
        },
        {
          value: '3',
          label: '样品审核不通过',
        },
      ],
      total: '',
      page: 1,

      created_at: '',
      product: '',
      // 物流信息
      wuliu: {
        no: '',
        cname: '',
        content: [],
      },
      number_id: '',
      dialogFormVisible4: false,
      dialogFormVisible3: false,
      dialogFormVisible2: false,
      dialogFormVisible: false,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      updateform: {
        job_remakr: '',
        job_status: '',
        experts_id: '',
        experts: '',
        product_name: '',
        guige: '',
        fenshu: '',
        post_name: '',
        post_telephone: '',
        post_address: '',
        colonel: '',
        express: '',
        id: '',
      },
      forminput: {
        experts_id: '',
        experts: '',
        product_name: '',
        guige: '',
        fenshu: '',
        post_name: '',
        post_telephone: '',
        post_address: '',
        colonel: '',
        express: '',
      },
      formLabelWidth: '120px',
      search: {
        currentNodeName: '',
        select: '',
        tuanzhang: '',
        qudao: '',
        product: '',
        keyword: '',
      },
      status: 0,
      tableData: [],
      id: '',
      pageSize: 10,
      pageNum: 0,
      total: 0,
      nodeIdId: 2,
      activeNames: ['2'],
      restaurants: [],
    }
  },
  created() {
    this.getAll()
    this.getProductList()
  },
  methods: {
    // 1. 先获取数据
    getProductList() {
      let params = new URLSearchParams()
      myExperts(params).then((res) => {
        console.log(res)
        if (res.data.length != 0) {
          let restaurants2 = res.data
          restaurants2.map((item, index) => {
            this.restaurants.push({
              // 只展示这个数组里的value值，受理商标等
              value: item.nickname,
              experts_id: item.unique_id,
              post_telephone: item.post_telephone,
              post_address: item.post_address,
            })
          })
        }
        console.log(this.restaurants)
      })
    },
    // // 2. 模糊搜索，输入值与获取到的数据进行比较
    proIdSearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      cb(results)
    },
    createFilter(queryString) {
      return (state) => {
        return state.value.indexOf(queryString) === 0
      }
    },

    // // 3. 选中值后，需要做的处理
    proIdSelect(item) {
      console.log(item)
      this.forminput.experts = item.value
      this.forminput.experts_id = item.experts_id
      this.forminput.post_address = item.post_address
      this.forminput.post_telephone = item.post_telephone
    },

    open(job_remakr) {
      this.dialogFormVisible5 = true
      this.updateform.job_remakr = job_remakr
    },
    querynum(id) {
      this.dialogFormVisible4 = true
      this.updateform.id = id
    },
    checknumber(id) {
      if (id != null) {
        this.dialogFormVisible3 = true
        this.querynumber(id)
      } else {
        this.$message.error('请完善物流信息')
      }
    },
    querynumber(id) {
      let params = new URLSearchParams()
      params.append('express', id)
      Epress(params)
        .then((res) => {
          let obj = JSON.parse(res.data)
          if (obj.status == 200) {
            this.$message.success('查询成功')
            this.wuliu.no = obj.no
            this.wuliu.cname = obj.cname
            this.wuliu.content = obj.list
          } else {
            this.$message.error(obj.message)
            this.dialogFormVisible3 = false
          }
        })
        .catch((err) => {})
    },
    guanbi() {
      this.show = false
      this.$refs.forminput2.resetFields()
    },
    guanbi2() {
      this.number_id = ''
      ;(this.wuliu.no = ''), (this.wuliu.cname = ''), (this.wuliu.content = [])
    },
    guanbi3() {
      this.updateform.job_remakr = ''
      this.updateform.job_status = ''
    },
    getAll2() {
      let params = new URLSearchParams()
      params.append('page', this.page)
      // params.append('page', this.pageSize)
      Getlist(params)
        .then((res) => {
          this.input3 = ''
          this.search.select = ''
          this.created_at = ''
          this.tableData = res.data.data
          this.total = res.data.total
          ;(this.created_at = ''),
            (this.keyword = ''),
            (this.product = ''),
            this.$message.success('重置成功！')
        })
        .catch((err) => {})
    },
    getadd() {
      this.$refs.forminput2.validate((valid) => {
        if (valid) {
          let params = new URLSearchParams()
          params.append('experts_id', this.forminput.experts_id)
          params.append('experts', this.forminput.experts)
          params.append('product_name', this.forminput.product_name)
          params.append('guige', this.forminput.guige)
          params.append('fenshu', this.forminput.fenshu)
          params.append('post_name', this.forminput.post_name)
          params.append('post_telephone', this.forminput.post_telephone)
          params.append('post_address', this.forminput.post_address)
          params.append('colonel', this.forminput.colonel)
          params.append('express', this.forminput.express)
          Add(params)
            .then((res) => {
              if (res.code == 200) {
                this.show = true
                this.dialogFormVisible = false
                this.$message.success('添加成功')
                this.getAll()
              } else {
                // swal('错误', res.message || '网络连接错误', 'error')
              }
            })
            .catch((err) => {
              if (err.request.status == 422) {
                this.dialogFormVisible = false
                this.$message.success('添加失败')
              }
            })
        }
      })
    },
    handleCurrentChange(val) {
      this.page = val
      this.getAll()
    },
    p(s) {
      return s < 10 ? '0' + s : s
    },
    // 查询达人信息
    getAll() {
      let resDate = ''
      let resDate2 = ''
      if (this.created_at == '') {
        resDate == ''
        resDate2 == ''
      } else {
        let d = new Date(this.created_at[0])
        resDate =
          d.getFullYear() +
          '-' +
          this.p(d.getMonth() + 1) +
          '-' +
          this.p(d.getDate())
        let d2 = new Date(this.created_at[1])
        resDate2 =
          d2.getFullYear() +
          '-' +
          this.p(d2.getMonth() + 1) +
          '-' +
          this.p(d2.getDate())
      }
      if (this.search.select == 1) {
        this.search.tuanzhang = this.input3
      } else if (this.search.select == 2) {
        this.search.keyword = this.input3
      }
      if (this.search.select == 3) {
        this.search.qudao = this.input3
      } else if (this.search.select == 4) {
        this.search.product = this.input3
      }
      let params = new URLSearchParams()
      params.append('page', this.page)
      params.append('qudao', this.search.qudao) //渠道
      params.append('tuanzhang', this.search.tuanzhang) // 团长
      params.append('keyword', this.search.keyword)
      params.append('start_time', resDate)
      params.append('end_time', resDate2)
      params.append('product', this.search.product)
      Getlist(params)
        .then((res) => {
          if (res.code == 200) {
            this.search.keyword = ''
            this.search.tuanzhang = ''
            this.search.qudao = ''
            this.created_at = ''
            this.tableData = res.data.data
            this.total = res.data.total
            this.page = 1
            if (this.search.select != '') {
              // this.$message.success("查询成功")
            } else {
            }
          }
        })
        .catch((err) => {
          if (res.code == 403) {
            this.$message.success('查询失败')
          }
        })
    },
    checkOption(list) {
      this.dialogFormVisible2 = true
      this.updateform.experts_id = list.experts_id
      this.updateform.experts = list.experts
      this.updateform.product_name = list.product_name
      this.updateform.guige = list.guige
      this.updateform.fenshu = list.fenshu
      this.updateform.post_name = list.post_name
      this.updateform.post_telephone = list.post_telephone
      this.updateform.post_address = list.post_address
      this.updateform.colonel = list.colonel
      this.updateform.express = list.express
      this.updateform.id = list.id
    },
    checkOption2(list) {
      this.dialogFormVisible6 = true
      this.updateform.experts_id = list.experts_id
      this.updateform.experts = list.experts
      this.updateform.product_name = list.product_name
      this.updateform.guige = list.guige
      this.updateform.fenshu = list.fenshu
      this.updateform.post_name = list.post_name
      this.updateform.post_telephone = list.post_telephone
      this.updateform.post_address = list.post_address
      this.updateform.colonel = list.colonel
      this.updateform.express = list.express
      this.updateform.id = list.id
    },
    update() {
      let params = new URLSearchParams()
      params.append('id', this.updateform.id)
      params.append('experts_id', this.updateform.experts_id)
      params.append('experts', this.updateform.experts)
      params.append('product_name', this.updateform.product_name)
      params.append('guige', this.updateform.guige)
      params.append('fenshu', this.updateform.fenshu)
      params.append('post_name', this.updateform.post_name)
      params.append('post_telephone', this.updateform.post_telephone)
      params.append('post_address', this.updateform.post_address)
      params.append('colonel', this.updateform.colonel)
      params.append('express', this.updateform.express)
      Update(params)
        .then((res) => {
          if (res.code == 200) {
            this.dialogFormVisible2 = false
            this.getAll()
            this.$message.success('更新成功')
          } else {
          }
        })
        .catch((err) => {
          this.dialogFormVisible2 = false
        })
    },
    del(id) {
      let params = new URLSearchParams()

      params.append('id', id)

      Del(params)
        .then((res) => {
          if (res.code == 200) {
            this.getAll()
            this.$message.success('删除成功')
          } else {
          }
        })
        .catch((err) => {
          this.$message.error('删除失败')
        })
    },
    update2() {
      let params = new URLSearchParams()
      if (this.updateform.job_status != '') {
        params.append('job_status', Number(this.updateform.job_status))
      }
      params.append('id', this.updateform.id)
      params.append('job_remakr', this.updateform.job_remakr)
      Update(params)
        .then((res) => {
          if (res.code == 200) {
            this.dialogFormVisible4 = false
            this.getAll()

            this.$message.success('添加成功')
          } else {
          }
        })
        .catch((err) => {
          this.dialogFormVisible4 = false
          this.$message.error('添加失败')
        })
    },
  },
}
</script>
<style>
.el-dropdown {
  margin-left: 5px;
  color: #4468b1 !important;
  font-size: 13px;
  font-weight: bold;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande',
    'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important;
}
.created_input {
  position: relative;
  left: 150px;
}
.el-form {
  width: 80%;
}
</style>
<style lang="less" scoped>
.page {
  padding: 10px;
  background-color: #ffff;
}
.btn_option {
  .el-button {
    width: 80px;
    height: 32px;
  }
}
.btn_option2 {
  .el-button {
    width: 80px;
    height: 32px;
  }
}
.one {
  line-height: 60px;
  .el-form {
    padding: 10px;
    display: flex;
    align-items: center;
  }
  height: 60px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 10px;
}
.cardBox {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/view/audit/audit.vue